<script setup lang="ts">
import { toggleActions } from "@/action/toggleActions";
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
</script>

<template>
  <div class="sightline-button" data-ignore-click>
    <BaseButton
      variant="ghost"
      color="grey"
      icon-before="general/sightline"
      aria-controls="sightline_panel"
      @click="toggleActions.toggleSightline('board-actions-menu')"
    >
      {{ $t("sightline.title") }}
    </BaseButton>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/variables/colors";
@use "@/styles/mixins/shadow";
@use "@/styles/mixins/typography";

@property --sightline-angle {
  syntax: "<angle>";
  inherits: true;
  initial-value: 270deg;
}

.sightline-button {
  --sightline-ring: conic-gradient(
    from var(--sightline-angle),
    #{colors.$primary-warning},
    #{colors.$alternative-blue},
    #{colors.$primary-warning}
  );

  display: flex;
  position: relative;
  width: fit-content;
  height: 40px;
  border: 2px solid transparent;
  border-radius: 20px;
  background:
    linear-gradient(colors.$background-ui, colors.$background-ui) padding-box,
    var(--sightline-ring) border-box;
  animation: sightline-spin 1.2s linear infinite paused;

  @include shadow.default;

  &::before {
    content: "";
    position: absolute;
    inset: -1px;
    z-index: -1;
    border-radius: inherit;
    background: var(--sightline-ring);
    filter: blur(3px);
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover {
    animation-play-state: running;

    &::before {
      opacity: 0.5;
    }

    :deep(.sightline-eye) {
      transform-box: fill-box;
      transform-origin: center;
      animation: sightline-blink 4s infinite;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;

    &:hover :deep(.sightline-eye) {
      animation: none;
    }
  }
}

.base-button[class] {
  @include typography.medium("semi-bold");

  gap: 4px;
  padding-inline: 12px 14px;
  height: 100%;
  border-radius: 18px;
}

@keyframes sightline-spin {
  to {
    --sightline-angle: 630deg;
  }
}

@keyframes sightline-blink {
  0%,
  5%,
  9.5%,
  14.5%,
  100% {
    transform: scaleY(1);
  }

  7%,
  12% {
    transform: scaleY(0.1);
  }
}
</style>
